import { FaGhost } from 'react-icons/fa'

const Error = () => {
	return (
		<div className='error-Page'>
			<h1>
				4
				<span>
					<FaGhost />
				</span>
				4
			</h1>
			<h2>Error: 404 page not found</h2>
			<p>We are sorry, But the page you are looking for does not exist.</p>
		</div>
	)
}

export default Error
